import React from 'react';
import { Microscope, Brain, Zap, Target, BookOpen, Users, ClipboardCheck, Building2 } from 'lucide-react';
import { features } from '../data/mock';
import { BrandName } from './BrandName';

const iconComponents = {
  Microscope,
  Brain,
  Zap,
  Target,
  BookOpen,
  Users,
};

const pillars = [
  {
    Icon: Users,
    title: 'Students First',
    desc: 'Designed for Class 9 to 12',
    gradient: 'from-blue-600 to-teal-500',
  },
  {
    Icon: ClipboardCheck,
    title: 'Career Assessments',
    desc: 'Quick and insightful',
    gradient: 'from-teal-600 to-cyan-500',
  },
  {
    Icon: Building2,
    title: 'School Integration',
    desc: 'Seamless and scalable',
    gradient: 'from-blue-600 to-indigo-600',
  },
];

const FeaturesSection = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-blue-50/30">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Why <BrandName /> Feels Different
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Because your future should feel like a choice you understand, not a maze you survive alone.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {features.map((feature) => {
            const IconComponent = iconComponents[feature.icon];
            return (
              <div
                key={feature.id}
                className="group bg-white p-8 rounded-2xl border border-gray-200 hover:border-blue-300 transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-teal-500 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-md">
                  <IconComponent className="w-7 h-7 text-white" />
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-16 md:mt-20 max-w-5xl mx-auto rounded-3xl border border-blue-100/90 bg-gradient-to-br from-white via-sky-50/40 to-teal-50/25 shadow-lg shadow-blue-900/5 overflow-hidden">
          <div className="grid grid-cols-1 sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-blue-100/80">
            {pillars.map((pillar) => (
              <div
                key={pillar.title}
                className="flex flex-col items-center text-center px-6 py-8 sm:py-10 sm:px-5 md:px-8"
              >
                <div
                  className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${pillar.gradient} flex items-center justify-center mb-4 shadow-md ring-4 ring-white/80`}
                >
                  <pillar.Icon className="w-7 h-7 text-white" strokeWidth={2} />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-1.5">{pillar.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed max-w-[14rem]">{pillar.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
